import request from "@/utils/request";


// 查询课程列表  分页/pc/online/EducationalCourseList
export const getEducationalCourseList = (params) => {
    return request({
        url: '/pc/online/EducationalCourseList',
        method: 'get',
        params
    })
}

// 获取资源列表分页/pc/online/getMaterialList
export const getMaterialList = (params) => {
    return request({
        url: '/pc/online/getMaterialList',
        method: 'get',
        params
    })
}

// 查询已购学时课程/pc/check/online/CourseList
export const CourseList = (params) => {
    return request({
        url: '/pc/check/online/CourseList',
        method: 'get',
        params
    })
}
// 查询已购选学课程/pc/check/online/resourceList
export const resourceList = (params) => {
    return request({
        url: '/pc/check/online/resourceList',
        method: 'get',
        params
    })
}

// 学时课程详细/pc/online/getCourseResource
export const getCourseDetail = (params) => {
    return request({
        url: '/pc/online/getCourseResource',
        method: 'get',
        params
    })
}
// 选学课程详细/pc/online/getMaterialInfo   
export const getMaterialInfo = (params) => {
    return request({
        url: '/pc/online/getMaterialInfo',
        method: 'get',
        params
    })
}


// native支付/pc/nativePay/wx5143b42ec9b0fe6c/createOrder
export const createOrder = (params) => {
    return request({
        url: '/pc/nativePay/wx5143b42ec9b0fe6c/createOrder',
        method: 'post',
        data: params
    })
}
// 扫码支付轮询订单状态/pc/nativePay/wx5143b42ec9b0fe6c/getPayStatus
export const getPayStatus = (params) => {
    return request({
        url: '/pc/nativePay/wx5143b42ec9b0fe6c/getPayStatus',
        method: 'get',
        params
    })
}
// 查询课程是否过期/pc/check/online/checkIsYearEndOver
// export const checkIsYearEndOver = (params) => {
//     return request({
//         url: '/pc/check/online/checkIsYearEndOver',
//         method: 'get',
//         params
//     })
// }

// /pc/check/online/getCourseResourcepc端根据不同的业务生成不同的资源信息
export const getCourseResource = (params) => {
    return request({
        url: '/pc/check/online/getCourseResource',
        method: 'get',
        params
    })
}

// c端查询章节树列表/pc/online/ChapterTree
export const getChapterTree = (params) => {
    return request({
        url: '/pc/online/ChapterTree',
        method: 'get',
        params
    })
}

// pc端根据专业获取所有的学时资源 /pc/check/online/getAllMaterialList
export const getAllMaterialList = (params) => {
    return request({
        url: '/pc/check/online/getAllMaterialList',
        method: 'get',
        params
    })
}

// pc端获取学员已选则的学时资源/pc/check/online/getMaterialList
export const getMaterialLists = (params) => {
    return request({
        url: '/pc/check/online/getMaterialList',
        method: 'get',
        params
    })
}
// pc端保存学时资源/pc/check/online/saveCourseResource
export const saveCourseResource = (params) => {
    return request({
        url: '/pc/check/online/saveCourseResource',
        method: 'post',
        data: params
    })
}

// pc端保存学习进度/pc/check/online/addTrainLearnRecord
export const addTrainLearnRecord = (params) => {
    return request({
        url: '/pc/check/online/addTrainLearnRecord',
        method: 'post',
        data: params
    })
}

// // /pc/online/ChapterTree  
// export const getChapterTree = (params) => {
//     return request({
//         url: '/pc/online/ChapterTree',
//         method: 'get',
//         params
//     })
// }

// /pc/check/online/bizTypeExamination  pc端根据不同的业务生成不同的试卷
export const bizTypeExamination = (params) => {
    return request({
        url: '/pc/check/online/bizTypeExamination',
        method: 'get',
        params
    })
}


// 考试试卷列表/pc/check/online/QuestionsConfig
export const QuestionsConfig = (params) => {
    return request({
        url: '/pc/check/online/QuestionsConfig',
        method: 'get',
        params
    })
}
// /pc/check/online/UpdateExamRecord交卷
export const UpdateExamRecord = (params) => {
    return request({
        url: '/pc/check/online/UpdateExamRecord',
        method: 'post',
        data: params
    })
}

// /pc/lt/CheckToken/getLearnProgress获取学习进度
export const getLearnProgress = (params) => {
    return request({
        url: '/pc/lt/CheckToken/getLearnProgress',
        method: 'get',
        params
    })
}

// 查询总学时 /wx/questions/getTotalDurationBySignup/{signupId}/{courseId}
export const getTotalDurationBySignup = (signupId, courseId) => {
    return request({
        url: '/wx/questions/getTotalDurationBySignup/' + signupId + '/' + courseId,
        method: 'get'
    })
}

// 检验课程是否年末过期 /pc/check/online/checkIsYearEndOver.
export const checkIsYearEndOver = (params) => {
    return request({
        url: '/pc/check/online/checkIsYearEndOver',
        method: 'get',
        params
    })
}

// 检查资源购买状态 /pc/check/online/checkIsByResource
export const getcheckIsByResource = (params) => {
    return request({
        url: '/pc/check/online/checkIsByResource',
        method: 'get',
        params
    })
}